"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_native_1 = require("react-native");
var ATLAtomChip_1 = require("../atoms/ATLAtomChip");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var TextCaseEnum_1 = require("../enums/TextCaseEnum");
var defaultProps = {
    clearButtonText: 'Limpar',
    multipleSelect: false,
    chipBaseProps: {},
    cleanChipBaseProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.ChipWrapper = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 ", "px;\n"], ["\n  padding: 0 ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingAtomic;
});
exports.ListWrapper = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "px 0;\n"], ["\n  padding: ", "px 0;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
});
var ListExtremities = styled_components_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", "px;\n"], ["\n  width: ", "px;\n"
    // ASSETS --------------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingAtomic;
});
// ASSETS --------------------------------------------------------------------------------------------------------------
var clearIcon = require('../assets/cancel.png');
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLChips = function (_a) {
    var items = _a.items, clearButtonText = _a.clearButtonText, onPressItem = _a.onPressItem, hasClearButton = _a.hasClearButton, multipleSelect = _a.multipleSelect, horizontalMargin = _a.horizontalMargin, horizontalPadding = _a.horizontalPadding, verticalMargin = _a.verticalMargin, chipBaseProps = _a.chipBaseProps, cleanChipBaseProps = _a.cleanChipBaseProps, initiallySelected = _a.initiallySelected;
    var theme = ThemeProvider_1.useTheme();
    var _b = react_1.useState(initiallySelected || []), currentlySelected = _b[0], setCurrentlySelected = _b[1];
    var filtersWithClean = (hasClearButton && currentlySelected.length > 0) ? __spreadArrays(items, ['clean']) : __spreadArrays(items);
    var renderChip = function (item, isSelected) { return (react_1.default.createElement(exports.ChipWrapper, { horizontalPadding: horizontalPadding },
        react_1.default.createElement(ATLAtomChip_1.ATLAtomChip, __assign({ text: item.text, iconLeft: item.icon, onPress: function () { return onPressChip(item.id); }, isSelected: isSelected, chipColorSelected: theme.ColorBrand1Default, chipColorUnselected: theme.ColorLowContrast, chipHeight: theme.HeightFilterChip, borderRadius: theme.BorderRadiusFilterChip, borderWidth: 0, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, iconPadding: theme.SpacingBase, iconSize: theme.SizeIconAuxiliary, textCase: TextCaseEnum_1.TextCaseEnum.none, textColorSelected: theme.ColorComplementary1, textColorUnselected: theme.ColorHighContrast }, chipBaseProps)))); };
    var renderClearChip = function () { return (react_1.default.createElement(exports.ChipWrapper, { horizontalPadding: horizontalPadding },
        react_1.default.createElement(ATLAtomChip_1.ATLAtomChip, __assign({ text: clearButtonText, iconRight: clearIcon, onPress: onPressClear, isSelected: false, chipColorUnselected: theme.ColorNone, chipBorderColorUnselected: theme.ColorLowContrast, rightIconColor: theme.ColorLowContrast, chipHeight: theme.HeightFilterChip, borderRadius: theme.BorderRadiusFilterChip, borderWidth: 1, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, iconPadding: theme.SpacingBase, iconSize: theme.SizeIconAuxiliary, textCase: TextCaseEnum_1.TextCaseEnum.none, textColorUnselected: theme.ColorBrand1Default }, cleanChipBaseProps)))); };
    var onPressClear = react_1.useCallback(function () {
        setCurrentlySelected([]);
    }, [currentlySelected]);
    var onClickMultipleSelect = react_1.useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedValues;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedValues = currentlySelected;
                    if (selectedValues.includes(id)) {
                        selectedValues.splice(selectedValues.indexOf(id), 1);
                    }
                    else {
                        selectedValues.push(id);
                    }
                    return [4 /*yield*/, setCurrentlySelected(__spreadArrays(selectedValues))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [currentlySelected]);
    var onPressChip = react_1.useCallback(function (id) {
        if (multipleSelect) {
            onClickMultipleSelect(id);
        }
        else {
            setCurrentlySelected(currentlySelected[0] === id ? [] : [id]);
        }
        onPressItem(id);
    }, [currentlySelected]);
    var renderItem = function (_a) {
        var item = _a.item;
        if (item === 'clean') {
            return (renderClearChip());
        }
        else {
            return (renderChip(item, currentlySelected.includes(item.id)));
        }
    };
    return (react_1.default.createElement(exports.ListWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
        react_1.default.createElement(react_native_1.FlatList, { data: filtersWithClean, renderItem: renderItem, horizontal: true, showsHorizontalScrollIndicator: false, ListHeaderComponent: react_1.default.createElement(ListExtremities, null), ListFooterComponent: react_1.default.createElement(ListExtremities, null) })));
};
exports.ATLChips.defaultProps = defaultProps;
exports.ATLChips.displayName = 'ATLChips';
var templateObject_1, templateObject_2, templateObject_3;
